import { render, staticRenderFns } from "./ProductListItem.vue?vue&type=template&id=6ba26ad6&scoped=true"
import script from "./ProductListItem.vue?vue&type=script&lang=js"
export * from "./ProductListItem.vue?vue&type=script&lang=js"
import style0 from "./ProductListItem.vue?vue&type=style&index=0&id=6ba26ad6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba26ad6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VehicleBulbBadge: require('/app/components/VehicleBulbBadge.vue').default,ProductListItemImages: require('/app/components/ProductListItemImages.vue').default,Label: require('/app/components/Label.vue').default,ProductListItemVariants: require('/app/components/ProductListItemVariants.vue').default,ProductListItemSpecs: require('/app/components/ProductListItemSpecs.vue').default,CommercialOperationBadge: require('/app/components/CommercialOperationBadge.vue').default,PriceDisplay: require('/app/components/PriceDisplay.vue').default,ProductStockStatus: require('/app/components/ProductStockStatus.vue').default,StarRatingLight: require('/app/components/StarRatingLight.vue').default})
